/**
 * Created by Abner Sui on 06/03/2020
 * -------------------------------------
 */

export enum BottomSlideSheetType {
    CLOSE = 'CLOSE',
    SHOW = 'SHOW',
}
